import canchiHero from "@/assets/villa-canchi-hero.webp";
import canchiPool from "@/assets/villa-canchi-pool.webp";
import canchiGarden from "@/assets/villa-canchi-garden.webp";
import canchiDining from "@/assets/villa-canchi-dining.webp";
import canchiLiving from "@/assets/villa-canchi-living.webp";
import canchiBedroom from "@/assets/villa-canchi-bedroom.webp";

import elephanteHero from "@/assets/villa-elephante-hero.webp";
import elephanteAerial from "@/assets/villa-elephante-aerial.webp";
import elephantePool from "@/assets/villa-elephante-pool.webp";
import elephantePool2 from "@/assets/villa-elephante-pool2.webp";
import elephanteDining from "@/assets/villa-elephante-dining.webp";
import elephanteLiving from "@/assets/villa-elephante-living.webp";

export interface Residence {
  slug: string;
  name: string;
  location: string;
  image: string;
  images: string[];
  bedrooms: string;
  bathrooms: string;
  guests: string;
  pools: string;
  area?: string;
  features: string[];
  pricing: {
    low: string;
    high: string;
  };
  priceNote: string;
  description: string;
  highlights: string[];
  distances: { place: string; time: string }[];
}

export const residences: Residence[] = [
  {
    slug: "can-chi",
    name: "Can Chi",
    location: "San Rafael, Ibiza",
    image: canchiHero,
    images: [canchiHero, canchiPool, canchiGarden, canchiDining, canchiLiving, canchiBedroom],
    bedrooms: "4",
    bathrooms: "3",
    guests: "Up to 8",
    pools: "1",
    features: [
      "Private pool (16m × 5m)",
      "Blakstad architecture",
      "SONOS sound system",
      "Air conditioning",
      "Underfloor heating",
      "BBQ & fireplace",
      "Security alarm",
      "Fitness / yoga area",
      "Large natural garden",
    ],
    pricing: {
      low: "€7.000",
      high: "€12.000",
    },
    priceNote: "Prices per week. Minimum stay applies during high season.",
    description:
      "A Blakstad-designed villa, located in a prime position in the centre of Ibiza island. The tranquil countryside location allows you to appreciate the island's nature whilst also allowing great access to all the island has to offer.\n\nThis rustic villa is built in line with Blakstad's view of maintaining a local, centuries-old traditional style of Ibizan architecture, albeit with fantastic modern features. The house exudes understated luxury, whilst maintaining many green, eco-conscious features, and it includes the latest technology, security and efficiency.\n\nPerfectly positioned in a tranquil location, the main house consists of 4 double bedrooms, 3 bathrooms, a large open plan living space, well equipped kitchen and dining room. Outside, the spacious garden has a large swimming pool, alfresco dining, many seating areas and a vast natural meadow for children to play.",
    highlights: [
      "South facing, all day sun exposure",
      "Open plan living with high ceilings",
      "Indoor & outdoor dining",
      "Large private garden & meadow",
    ],
    distances: [
      { place: "San Antonio City", time: "10 min drive" },
      { place: "Ibiza Marina", time: "12 min drive" },
      { place: "Santa Eularia Town", time: "15 min drive" },
      { place: "Ibiza Airport", time: "18 min drive" },
    ],
  },
  {
    slug: "casa-elephante",
    name: "Casa Elephante",
    location: "Roca Llisa, Ibiza",
    image: elephanteHero,
    images: [elephanteHero, elephanteAerial, elephantePool, elephantePool2, elephanteDining, elephanteLiving],
    bedrooms: "8",
    bathrooms: "8",
    guests: "Up to 16",
    pools: "2",
    features: [
      "2 Private pools (1 heated)",
      "Poolside hot tub",
      "Rooftop lounge",
      "Outdoor kitchen & BBQ",
      "Fitness room",
      "Pool table",
      "Table tennis",
      "Sky TV & sound system",
      "Wi-Fi throughout",
      "Expansive gardens",
    ],
    pricing: {
      low: "€15.000",
      high: "€25.000",
    },
    priceNote: "Prices per week. Minimum stay applies during high season.",
    description:
      "Casa Elephante is nestled within the exclusive and stylishly gated community of Roca Llisa in Ibiza, a favoured residence for the international elite.\n\nSpanning two levels with awe-inspiring views, this meticulously modernised villa accommodates up to 16 individuals with comfort, catering to large families or groups of friends. The villa boasts 8 double bedrooms, each equipped with an en-suite bathroom, air conditioning, a sound system, and an LCD TV.\n\nEnjoy the luxury of 2 private swimming pools, one of which is heated, accompanied by ample sunbathing areas and a poolside hot tub. Additional amenities include a table-tennis table, badminton setup, pool table, fitness room, study, outdoor yoga platform, expansive gardens, and laid-back terraces. The island's only golf course is an integral part of the picturesque nearby landscape.",
    highlights: [
      "Gated community of Roca Llisa",
      "8 en-suite bedrooms across 2 levels",
      "2 pools with hot tub",
      "Rooftop terrace with panoramic views",
    ],
    distances: [
      { place: "Beach & golf course", time: "5 min" },
      { place: "Ibiza Town", time: "10 min" },
      { place: "Santa Eulalia", time: "15 min" },
      { place: "San Antonio", time: "30 min" },
    ],
  },
];
